import { Button, Pagination, Space, Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import React, { useState } from "react";
import { PaginationProps } from "antd/lib/pagination";
import { CONSTANT } from "../../../../config/Constant";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import ViewReport from "./ViewReport";
import DeleteReport from "./DeleteReport";
import ExportCSVReport from "../../../../components/ExportCSVReport";
import moment from "moment";

interface DataType {
  index: number;
  row_id: number;
  id: string;
  type: string;
  report_date: string;
  prefix: number;
  response: string;
  created_date: string | any;
}

const ListTable: React.FC<any> = (props) => {
  const {
    listData,
    setListData,
    totalData,
    tableloading,
    setTableLoading,
    paginationData,
    setPaginationData,
    getList,
    savePayload,
  } = props;

  const [openUpdateModal, setOpenUpdateModal] = useState<boolean>(false);
  const [openUpdateData, setOpenUpdateData] = useState<any>();
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [openDeleteData, setOpenDeleteData] = useState<any>();

  const handleDeleteRequest = (record: any) => {
    setOpenDeleteModal(!openDeleteModal);
    setOpenDeleteData(record);
  };

  const handleDeleteRequestClose = (record: any) => {
    setOpenDeleteModal(false);
    setOpenDeleteData({});
  };

  const columns: ColumnsType<DataType> = [
    {
      title: "ID",
      key: "id",
      dataIndex: "id",
      width: 200,
      className: "reportType",
      fixed: "left",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.id.localeCompare(b.id),
    },
    {
      title: "Prefix",
      dataIndex: "prefix",
      key: "prefix",
      width: 180,
      sortDirections: ["descend", "ascend"],
      render: (_, record) => {
        return record?.prefix ? record?.prefix : CONSTANT.NO_DATA_FOUND;
      },
      fixed: "left",
    },
    {
      title: "Created Date",
      dataIndex: "created_date",
      key: "created_date",
      width: 200,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        a?.created_date?.toString().localeCompare(b?.created_date),
      render: (_, record) => {
        return record?.created_date ? record?.created_date : "-";
      },
    },
    {
      title: "Action",
      key: "action",
      width: 200,
      // fixed: 'right',
      render: (_, record) => {
        let viewData = record?.response ? JSON.parse(record?.response) : null;

        viewData = viewData.map((ele) => {
          return {
            ...ele,
            created: moment(ele.created).format("YYYY-MM-DD hh:mm:ss a"),
            updated: moment(ele.updated).format("YYYY-MM-DD hh:mm:ss a"),
          };
        });

        return (
          <Space size="middle">
            <Tooltip title={"View Report"}>
              <Button
                type="default"
                icon={<EyeOutlined />}
                className="EditBtn iconBtn"
                onClick={() => handleViewReport(record)}
              />
            </Tooltip>
            <Tooltip title={"Asterisk Number By Shadow Prefix Report"}>
              {viewData && (
                <ExportCSVReport
                  elements={viewData}
                  reportName={`asterisk-number-by-shadow-prefix-${record.prefix}-${Date.now()}`}
                  label={false}
                />
              )}
            </Tooltip>
            <Tooltip title={"Delete Report"}>
              <Button
                onClick={() => {
                  handleDeleteRequest(record);
                }}
                icon={<DeleteOutlined />}
                type="default"
                className="cancelBtn iconBtn"
              />
            </Tooltip>
          </Space>
        );
      },
    },
  ];

  const providersData: DataType[] = listData?.map((item, index) => ({
    key: index.toString(),
    index: item.index,
    id: item._id,
    row_id: item._id,
    prefix: item?.prefix,
    report_date: item?.date,
    response: item?.response,
    created_date: item?.created_date,
  }));

  const handleChange: PaginationProps["onChange"] = (current, page_size) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (
    current,
    page_size
  ) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  const handleViewReport = (data: any) => {
    setOpenUpdateModal(!openUpdateModal);
    setOpenUpdateData(data);
  };

  return (
    <>
      <div className="responsiveTable">
        <Table
          dataSource={providersData}
          columns={columns}
          pagination={false}
          loading={tableloading}
        />
        <div className="text-center mt-20 mb-30 providerTable">
          <Pagination
            defaultCurrent={1}
            current={paginationData?.current}
            total={totalData ?? 0}
            onChange={handleChange}
            responsive={true}
            pageSize={paginationData?.page_size}
            // showSizeChanger={totalData ? true : false}
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            pageSizeOptions={CONSTANT.PER_PAGE_RECORD}
          />
        </div>
      </div>

      {openUpdateModal && (
        <ViewReport
          openUpdateModal={openUpdateModal}
          openUpdateData={openUpdateData}
          handleViewReport={handleViewReport}
        />
      )}

      <DeleteReport
        // title={openDeleteData?.id}
        title={"Report"}
        close={handleDeleteRequestClose}
        open={openDeleteModal}
        deleteValues={openDeleteData?.row_id}
        getList={getList}
      />
    </>
  );
};
export default ListTable;
